interface IEnvConfig {
  REPORT_SERVER_DOMAIN: string;
}

const envConfig: IEnvConfig = {
  REPORT_SERVER_DOMAIN: process.env.REACT_APP_REPORT_SERVER_DOMAIN || "",
};

export default envConfig;
